import React, { useMemo } from 'react';
import { Tab } from 'semantic-ui-react';

import { styled } from '@modules/common/components/ThemeProvider/utils';

export type TabsProps = {
  tabs: { title: string; content: React.ReactNode }[];
  loading: boolean;
};

function Tabs({ tabs, loading }: TabsProps) {
  const panes = useMemo(
    () =>
      tabs.map(({ title, content }) => ({
        menuItem: title,
        render: () => <StyledTabPane loading={loading}>{content}</StyledTabPane>,
      })),
    [tabs, loading],
  );
  return <StyledTab panes={panes} />;
}

export default Tabs;

const StyledTab = styled(Tab)`
  margin-top: 1rem;

  .ui.tabular.menu .item {
    border-radius: 0 !important;

    :not(.active) {
      border-top: 1px solid #d4d4d5;
      border-right: 1px solid #d4d4d5;
      border-left: 1px solid #d4d4d5;
      border-radius: 5px 5px 0 0;
    }
  }
`;
const StyledTabPane = styled(Tab.Pane)`
  max-height: 450px;
  overflow: auto;
  border-radius: 0 !important;
`;
